// Budget lock for "Fast pris" projects: once Actual Hours reaches Budgeted
// Hours (or 120% of it when the "20% Buffer" checkbox is set in Zoho), the
// project can no longer be picked for new time registrations.

export const BUDGET_LOCKED_MESSAGE =
  'Du kan desværre ikke registrere flere timer på dette projekt. Kontakt din projektleder hvis du alligevel har behov for at registrere yderligere tid.';

// Zoho returns budget hours as "HH:MM" strings (e.g. "81:00", "09:30").
// Missing or unparseable values count as 0 minutes.
export function parseZohoHoursToMinutes(value) {
  if (typeof value !== 'string') return 0;
  const match = value.replace(/[.,\s]/g, '').match(/^(\d+):(\d{1,2})$/);
  if (!match) return 0;
  return Number(match[1]) * 60 + Number(match[2]);
}

export function isProjectBudgetLocked(project) {
  if (!project || project.fakturering !== 'Fast pris') return false;
  const budget = parseZohoHoursToMinutes(project.budgetedHours);
  const actual = parseZohoHoursToMinutes(project.actualHours);
  const hasBuffer = project.buffer20 === true || project.buffer20 === 'true';
  // Integer comparison: actual >= budget * 1.2 written as actual * 5 >= budget * 6.
  return hasBuffer ? actual * 5 >= budget * 6 : actual >= budget;
}
